<template>
  <Modal name="newReport" v-bind="$attrs" :key='id'>
    <template v-slot:header>
        <h1>{{ $t('select_path') }}</h1>
    </template>
    <template v-slot:body>
        <div class="border flex rounded row overflow-x-auto">
            <div class="col w-1/2 max-h-64 overflow-y-auto flex-grow-0 flex-shrink-0 border-r">
                <div class="list flex-grow">
                    <ul class="">
                        <li v-for="path in paths" :key="path.id" :id="path.id" class="flex items-center justify-between p-2 hover:bg-gray-100 transition cursor-pointer" :class="selected.id == path.id ? 'active' : null" @click="select(path)">
                            {{path.name}}
                            <feather v-show="path.children" type="chevron-right" stroke='#141935'></feather>
                        </li>
                    </ul>
                </div>
            </div>
            <div
            v-for="(window, index) in structure" :key="index"
            class="col w-1/2 max-h-64 overflow-y-auto flex-grow-0 flex-shrink-0 border-r last:border-0">
                <div class="list flex-grow">
                    <ul class="">
                        <li v-for="path in window.children" :key="path.id" :id="path.id" class="flex items-center justify-between p-2 hover:bg-gray-100 transition cursor-pointer" :class="selected.id == path.id ? 'active' : null" @click="select(path)">
                            {{path.name}}
                            <feather v-show="path.children" type="chevron-right" stroke='#141935'></feather>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </template>
    <template v-slot:footer>
        <div class="btn btn-primary submit" :class="!isValid ? 'disabled' : null" @click="submit">
            <feather size="24px" :type="isSingleValueOnly ? 'check-circle' : 'plus'" /> {{ isSingleValueOnly ? $t('select_path') : $t('add_new') }}
        </div>
    </template>
</Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '../modules/modals/components/Modal'
import Vue from "vue";

export default {
    name: 'modalSelectFilterPath',
    components: {
        Modal,
    },
    props: {
        filterName: {
            type: String,
            required: true,
        },
        paths: {
            type: Array,
            required: true,
        }
    },
    data(){
        return {
            id: null,
            data: null,
            selected: {},
            structure: [],
        }
    },
    computed: {
        ...mapGetters(['newReport']),
        isValid(){
            if(this.selected.path){
                return true
            } else {
                return false
            }
        },
        isSingleValueOnly() {
            return this.filterName === Vue.Constants.PATH_ENUM_FILTER_NAME
        }

    },
    methods: {
        ...mapMutations({
            setNewReportItem: 'setNewReportItem',
        }),
        ...mapActions({

        }),
        submit(){
            // const vm = this

            if(this.isValid){
                let filters = this.newReport.filters
                let pathsIndex = filters.findIndex(filter => filter.name == this.filterName)
                let paths = filters[pathsIndex]
                let index = -1
                if(paths.value && paths.value.length){
                    index = paths.value.findIndex(item => item == this.selected.path)
                } else {
                    paths.value = []
                }

                if(index == -1){
                    if(this.isSingleValueOnly) filters[pathsIndex].value = []
                    filters[pathsIndex].value.push(this.selected.path)

                    this.setNewReportItem({filters: filters})
                }
                this.$attrs.close()
            }
        },
        select(item){
            if(this.selected.id === item.id){
                this.selected = {}
            } else {
                this.selected = item
                this.setActive(item.id)
                this.$nextTick(()=>{
                    document.getElementById(item.id).scrollIntoView({behavior: 'smooth', block: 'start', inline: 'start'})
                })
            }
        },
        setActive(id){
            let temp = [];
            let stop = false
            function search(source, id){
                for(let i = 0; i < source.length; i++){
                    if(!stop){
                        if(source[i].id == id){
                            temp.push(source[i])
                            stop = true
                            return
                        } else if(source[i].children && source[i].children.length){
                            search(source[i].children, id)
                            if(stop) {
                                temp.unshift(source[i])
                                return temp
                            }
                        }
                    }
                }
                return temp
            }
            search(this.paths, id)
            this.structure = [...temp]
        },
    },
    mounted() {
        this.data = null
    }
}
</script>

<style lang="sass" scoped>
@import "../colours"
h1
    font-size: 25px!important
.active
    background-color: $lightSparkYellow!important
.row
    scroll-snap-type: x mandatory
    >.col
        scroll-snap-align: start
</style>
